export const uk = {
    'needs-price': 'Цена не может быть пустой',
    'price-error-text': 'Произошла непредвиденная ошибка. Повторите попытку позже.',
    'price-greater-then-max': 'Цена больше максимально допустимого значения',
    'price-greater-then-max-with-value': 'Цена не может быть больше {value}',
    'price-greater-then-min': 'Цена не может быть меньше и равна {value}',
    'price-validate-error': 'Произошла ошибка валидации. Повторите попытку позже',
    'priceOld-greater-then-max': 'Старая цена больше максимально допустимого значения',
    'priceOld-greater-then-max-with-value': 'Старая цена не может быть больше {value}',
    'priceOld-greater-then-min': 'Cтарая цена не может быть меньше и равна {value}',
    'priceOld-greater-then-price': 'Старая цена должна быть больше новой цены'
};
